// extracted by mini-css-extract-plugin
export var button = "ButtonV2-module--button--d2a8b";
export var dark = "ButtonV2-module--dark--4a151";
export var disabled = "ButtonV2-module--disabled--79902";
export var fill = "ButtonV2-module--fill--70df1";
export var light = "ButtonV2-module--light--a17c1";
export var outline = "ButtonV2-module--outline--e015d";